import { render } from "./Currencys.vue?vue&type=template&id=75af12d9"
import script from "./Currencys.vue?vue&type=script&lang=js"
export * from "./Currencys.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Proyectos\\ERP ELECTRONICO\\ERP-FRONT\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__